import Issues from '@/modules/ticket/issues/store';

export default { modules: [Issues] };
